
const low = '#01cc5d'
const medium = '#7cb904'
const high = '#eec500'
const warning = '#fc6d00' 
const danger = '#cd0000'

const border = {
    'news': {
      0: low,
      1: low,
      2: high,
      3: high,
      4: high,
      5: high,
      6: warning,
      7: warning,
      8: danger,
      9: danger,
      10: danger,
      11: danger,
      12: danger,
      13: danger,
      14: danger,
      15: danger,
      16: danger,
      17: danger,
      18: danger,
      19: danger,
      20: danger,
      21: danger,
      22: danger,
      23: danger,
      24: danger,
      25: danger,
      26: danger,
      27: danger,
      28: danger
    },
    'pews': {
      0: low,
      1: low,
      2: high,
      3: high,
      4: high,
      5: high,
      6: high,
      7: high,
      8: danger,
      9: danger,
      10: danger,
      11: danger,
      12: danger,
      13: danger,
      14: danger,
      15: danger,
      16: danger,
      17: danger,
      18: danger,
      19: danger,
      20: danger,
      21: danger,
      22: danger,
      23: danger,
      24: danger,
      25: danger,
      26: danger,
      27: danger,
      28: danger,
      29: danger,
      30: danger
    },
    'coast': {
      0: low,
      1: low,
      2: high,
      3: high,
      4: danger,
      5: danger,
      6: danger
    }
}

exports.border = border;
